import React, { Component } from 'react'
import { connect } from 'react-redux'
import history from '../utils/history'

import Box from '../components/Layout/Box'
import BoxButton from '../components/Layout/BoxButton'
import ButtonStrip from '../components/Layout/ButtonStrip'

import { signOut } from '../actions/auth'
import { updateInputs, actualizarContrasena } from '../actions/cambiarcontrasena';
import { target } from 'glamor';

class CambiarContrasena extends Component {
    componentWillMount() {
        if (!this.props.user) {
            history.push(window.FOLDER + '/signin')
            this.props.signOut()
            return
        }
        if (!!this.props.user.get('ldap')) {
            history.push(window.FOLDER + '/')
        }
    }

	render() {
        const boxActions = [
            <BoxButton key="ba[0][1]" name="floppy-o" onClick={ () => this.props.actualizarContrasena() } title="Guardar" />
        ]

		return (
            <div className="row" style={{ height: '100%' }}>
                <div className="col-md-12" style={{ height: '100%' }}>
                    <Box title="Cambiar contraseña" stretch>
                        <ButtonStrip 
                            actions={boxActions}
                        />
                        <div className="box-content" style={{ flex: 1, height: 0, overflow: 'auto' }}>
                            <div className="col-md-12">
                                <div className="row">
                                    <div className="col-md-4">
                                        <div className="form-group">
                                            <label className="control-label">Contraseña actual</label>
                                            <input type="password" value={ this.props.form.get('passwordactual') || ''} className="form-control input-sm" onChange={ e => this.props.updateInputs('passwordactual', e.target.value) } />
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-4">
                                        <div className="form-group">
                                            <label className="control-label">Nueva contraseña</label>
                                            <input type="password" value={ this.props.form.get('passwordnuevo') || ''} className="form-control input-sm" onChange={ e => this.props.updateInputs('passwordnuevo', e.target.value) } />
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-4">
                                        <div className="form-group">
                                            <label className="control-label">Verificacion nueva contraseña</label>
                                            <input type="password" value={ this.props.form.get('verificacion') || ''} className="form-control input-sm" onChange={ e => this.props.updateInputs('verificacion', e.target.value) } />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Box>
                </div>
            </div>
		)
	}
}

function mapStateToProps(state) {
    return {
        user: state.common.get('user'),
        form: state.cambiarcontrasena,
    }
}

function mapDispatchToProps(dispatch) {
    return {
        signOut: () => dispatch(signOut()),
        updateInputs: (path, value) => dispatch(updateInputs(path, value)),
        actualizarContrasena: () => dispatch(actualizarContrasena()),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(CambiarContrasena)


// WEBPACK FOOTER //
// ./src/containers/CambiarContrasena.jsx